import React from 'react'
import { Edit, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate, BooleanInput } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

export const CompanyEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.updated_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.company') }
    })
    redirect('/company')
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.company') }
    })
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_company')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['short_name']} genderElement='femenine' />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.code_iata')} required>
              <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.slug')}>
              <TextInput source='slug' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
